import { render, staticRenderFns } from "./DailyRecoveriesLKBarchart.vue?vue&type=template&id=170bfb62&"
import script from "./DailyRecoveriesLKBarchart.vue?vue&type=script&lang=js&"
export * from "./DailyRecoveriesLKBarchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports